import { Component,  OnInit, EventEmitter, Output, Input } from '@angular/core';
import {
  ReactiveFormsModule,
  FormGroup,
  FormControl,
  Validators,
  AbstractControl,
  FormBuilder,
  FormsModule,
} from '@angular/forms';
import { MatTabsModule } from '@angular/material/tabs';

import { LoquateFinderComponent } from "../../../../../../Shared/_components/loquate-finder/loquate-finder.component";
import { TrimInputDirective } from '../../../../../../Shared/_directives/trim-input.directive';

@Component({
    selector: 'app-billing-form',
    imports: [
    ReactiveFormsModule,
    MatTabsModule,
    FormsModule,
    LoquateFinderComponent,
    TrimInputDirective
],
    templateUrl: './billing-form.component.html',
    styleUrl: './billing-form.component.css'
})
export class BillingFormComponent {
  @Output() formValid = new EventEmitter<{
    billingAddress: any;
    shippingAddress?: any;
  }>();
  activeTab = 1;
  sameShippingAddress = true;
  submitted = false;
  @Input() defaultShippingAddress?: any;
  @Input() defaultBillingAddress?: any;

  formFields = {
    firstName: new FormControl(''),
    lastName: new FormControl(''),
    phoneNo: new FormControl(''),
    address1: new FormControl(''),
    address2: new FormControl(''),
    city: new FormControl(''),
    country: new FormControl(''),
    postCode: new FormControl(''),
    email: new FormControl(''),
  };

  validations = {
    firstName: new FormControl('', [
      Validators.required,
      Validators.minLength(2),
      Validators.maxLength(100),
    ]),
    lastName: new FormControl('', [
      Validators.required,
      Validators.minLength(2),
      Validators.maxLength(200),
    ]),
    phoneNo: new FormControl('', [
      Validators.required,
      // UK and international numbers: digits with spaces, +, brackets or dashes.
      Validators.pattern('^\\+?[0-9 ()-]{7,20}$'),
    ]),
    address1: new FormControl('', [
      Validators.required,
      Validators.minLength(3),
      Validators.maxLength(200),
    ]),
    address2: new FormControl('', [
      Validators.maxLength(200),
    ]),
    city: new FormControl('', [
      Validators.required,
      Validators.minLength(2),
      Validators.maxLength(200),
    ]),
    country: new FormControl('', [
      //Validators.required,
      Validators.minLength(2),
      Validators.maxLength(200),
    ]),
    postCode: new FormControl('', [
      Validators.required,
      Validators.minLength(2),
      Validators.maxLength(20),
    ]),
    email: new FormControl('', [Validators.required, Validators.email]),
  };

  // this was needed
  validatedDuplicated = {
    firstName: new FormControl('', [
      Validators.required,
      Validators.minLength(2),
      Validators.maxLength(100),
    ]),
    lastName: new FormControl('', [
      Validators.required,
      Validators.minLength(2),
      Validators.maxLength(200),
    ]),
    phoneNo: new FormControl('', [
      Validators.required,
      // UK and international numbers: digits with spaces, +, brackets or dashes.
      Validators.pattern('^\\+?[0-9 ()-]{7,20}$'),
    ]),
    address1: new FormControl('', [
      Validators.required,
      Validators.minLength(3),
      Validators.maxLength(200),
    ]),
    address2: new FormControl('', [
      Validators.maxLength(200),
    ]),
    city: new FormControl('', [
      Validators.required,
      Validators.minLength(2),
      Validators.maxLength(200),
    ]),
    country: new FormControl('', [
      Validators.minLength(2),
      Validators.maxLength(200),
    ]),
    postCode: new FormControl('', [
      Validators.required,
      Validators.minLength(2),
      Validators.maxLength(20),
    ]),
    email: new FormControl('', [Validators.required, Validators.email]),
  };

  billingDetailsFrom: FormGroup = new FormGroup(this.formFields);
  shippingDetailsFrom: FormGroup = new FormGroup(this.formFields);

  constructor(
    private formBuilder: FormBuilder,
    //private alertService: AlertService
  ) {}

  ngOnInit(): void {
    this.billingDetailsFrom = this.formBuilder.group(this.validations);
    this.shippingDetailsFrom = this.formBuilder.group(this.validatedDuplicated);

    if (this.defaultBillingAddress) {
      this.billingDetailsFrom.setValue({
        firstName : this.defaultBillingAddress.firstName,
        lastName: this.defaultBillingAddress.lastName,
        phoneNo:  this.defaultBillingAddress.phoneNo,
        address1:  this.defaultBillingAddress.address1,
        address2:  this.defaultBillingAddress.address2,
        city:  this.defaultBillingAddress.city,
        country:  this.defaultBillingAddress.country,
        postCode:  this.defaultBillingAddress.postCode,
        email:  this.defaultBillingAddress.email,
      }
      );
    }
    if (this.defaultShippingAddress) {
      this.sameShippingAddress = false;
      this.shippingDetailsFrom.setValue({
        firstName : this.defaultShippingAddress.firstName,
        lastName: this.defaultShippingAddress.lastName,
        phoneNo:  this.defaultShippingAddress.phoneNo,
        address1:  this.defaultShippingAddress.address1,
        address2:  this.defaultShippingAddress.address2,
        city:  this.defaultShippingAddress.city,
        country:  this.defaultShippingAddress.country,
        postCode:  this.defaultShippingAddress.postCode,
        email:  this.defaultShippingAddress.email,
      }
      );
    }
    // Returning here after stepping back to pick more products should show
    // the already-saved details, not a blank form the agent has to refill.
    if (this.defaultBillingAddress) {
      this.disableForms();
    }
  }

  // This is needed for the reactive forms, I don't know why
  get f(): { [key: string]: AbstractControl } {
    return this.billingDetailsFrom.controls;
  }
  get fs(): { [key: string]: AbstractControl } {
    return this.shippingDetailsFrom.controls;
  }

  onGotToShippingAddressForm() {
    if (!this.sameShippingAddress) this.activeTab = 2;
  }
  
  onAddressSelected(data: any) {
    const addressData = data.addressData;
    const type = data.type;
    addressData['firstName'] = this.billingDetailsFrom.get('firstName')?.value;
    addressData['lastName'] = this.billingDetailsFrom.get('lastName')?.value;
   // addressData['companyName'] = this.billingDetailsFrom.get('companyName')?.value;
    addressData['phoneNo'] = this.billingDetailsFrom.get('phoneNo')?.value;
    addressData['email'] = this.billingDetailsFrom.get('email')?.value;
    if (type === 'billing') this.billingDetailsFrom.setValue(addressData);
    if (type === 'billing' && !this.sameShippingAddress) this.shippingDetailsFrom.setValue(addressData);
    if (type === 'shipping') this.shippingDetailsFrom.setValue(addressData);
  }

  isFormValid() {
    if (this.sameShippingAddress && this.billingDetailsFrom.valid) {
      return true;
    }
    if (
      !this.sameShippingAddress &&
      this.billingDetailsFrom.valid &&
      this.shippingDetailsFrom.valid
    ) {
      return true;
    }
    return false;
  }

  onSubmit() {
    const bv = this.billingDetailsFrom.value;
    let toParent = {
      billingAddress: {
        firstName: bv.firstName?.trim(),
        lastName: bv.lastName?.trim(),
        phoneNo: bv.phoneNo?.trim(),
        address1: bv.address1?.trim(),
        address2: bv.address2?.trim() ?? bv.address2,
        city: bv.city?.trim(),
        country: bv.country?.trim() ?? bv.country,
        postCode: bv.postCode?.trim(),
        email: bv.email?.trim(),
      },
      sameShippingAddress: this.sameShippingAddress,
      shippingAddress: undefined as any,
    };
    if (!this.sameShippingAddress && this.shippingDetailsFrom.valid) {
      const sv = this.shippingDetailsFrom.value;
      toParent.shippingAddress = {
        firstName: sv.firstName?.trim(),
        lastName: sv.lastName?.trim(),
        phoneNo: sv.phoneNo?.trim(),
        address1: sv.address1?.trim(),
        address2: sv.address2?.trim() ?? sv.address2,
        city: sv.city?.trim(),
        country: sv.country?.trim() ?? sv.country,
        postCode: sv.postCode?.trim(),
        email: sv.email?.trim(),
      };
    }
    this.formValid.emit(toParent);
    this.disableForms();
  }

  disableForms() {
    this.submitted = true;
    this.billingDetailsFrom.disable();
    this.shippingDetailsFrom.disable();
  }

  enableForms() {
    this.submitted = false;
    this.billingDetailsFrom.enable();
    this.shippingDetailsFrom.enable();
  }


}


